// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating_c2ccfae5 {
  z-index: 80;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.24), 0 0 2px 0 rgba(0,0,0,0.12);
  border: 1px solid #d8dde3;
  border-radius: 0.333em;
  transition-timing-function: ease-in-out;
  transition-property: opacity;
}
.floating_c2ccfae5.flip_c2ccfae5 {
  box-shadow: 0 -2px 2px 0 rgba(0,0,0,0.24), 0 0 2px 0 rgba(0,0,0,0.12);
}
.floating_c2ccfae5.initial_c2ccfae5 {
  opacity: 0;
}
.floating_c2ccfae5.open_c2ccfae5 {
  transition-duration: 150ms;
}
.floating_c2ccfae5.close_c2ccfae5 {
  transition-duration: 150ms;
  opacity: 0;
}
.floating_c2ccfae5.unmounted_c2ccfae5 {
  display: none;
}
.floating_c2ccfae5 [data-overlayscrollbars-contents] {
  overscroll-behavior: contain;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"floating": `floating_c2ccfae5`,
	"flip": `flip_c2ccfae5`,
	"initial": `initial_c2ccfae5`,
	"open": `open_c2ccfae5`,
	"close": `close_c2ccfae5`,
	"unmounted": `unmounted_c2ccfae5`
};
export default ___CSS_LOADER_EXPORT___;
